module.exports = __webpack_public_path__ + "static/the-15-invaluable-laws-of-growth-5d31abb282c391bf9b38e59a9f1bcdd4.jpg";